<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/nAqcCH/tc-custom/9780226473796.jpg?1737196543919" alt="This image is the cover for the book Seductive Journey"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Seductive Journey
      </h1>
      <p class="bookDescription body article font2">
        <p>For centuries, France has cast an extraordinary spell on travelers. Harvey Levenstein's <i>Seductive Journey</i> explains why so many Americans have visited it, and tells, in colorful detail, what they did when they got there. The result is a highly entertaining examination of the transformation of American attitudes toward French food, sex, and culture, as well as an absorbing exploration of changing notions of class, gender, race, and nationality.<br/><br/> Levenstein begins in 1786, when Thomas Jefferson instructed young upper-class American men to travel overseas for self-improvement rather than debauchery. Inspired by these sentiments, many men crossed the Atlantic to develop "taste" and refinement. However, the introduction of the transatlantic steamship in the mid-nineteenth century opened France to people further down the class ladder. As the upper class distanced themselves from the lower-class travelers, tourism in search of culture gave way to the tourism of "conspicuous leisure," sex, and sensuality. Cultural tourism became identified with social-climbing upper-middle-class women. In the 1920s, prohibition in America and a new middle class intent on "having fun" helped make drunken sprees in Paris more enticing than trudging through the Louvre. Bitter outbursts of French anti-Americanism failed to jolt the American ideal of a sensual, happy-go-lucky France, full of <i>joie de vivre</i>. It remained Americans' favorite overseas destination.<br/><br/> From Fragonard to <i>foie gras</i>, the delicious details of this story of how American visitors to France responded to changing notions of leisure and blazed the trail for modern mass tourism makes for delightful, thought-provoking reading.<br/><br/> "...a thoroughly readable and highly likable book."—Deirdre Blair, <i>New York Times Book Review</i></p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Harvey Levenstein
      </h2>
      
      <p class="authorDescription body article"><B>Harvey Levenstein</B> is professor emeritus of history at McMaster University in Hamilton, Ontario. He has published a number of books on American history, including <I>Revolution at the Table: The Transformation of the American Diet</I> and <I>Paradox of Plenty: A Social History of Eating in Modern America</I>.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      The University of Chicago Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?d8023790